/* STH Extras - Back to Top + Smart Sticky */

// Back to Top
(function(){
  var btn=document.createElement('button');
  btn.innerHTML='&#8593;';
  btn.setAttribute('aria-label','Back to top');
  btn.style.cssText='position:fixed;bottom:24px;right:24px;width:44px;height:44px;border-radius:50%;background:#2A2724;color:#F5F1EA;border:none;font-size:20px;cursor:pointer;opacity:0;visibility:hidden;transition:opacity .3s,visibility .3s;z-index:90;box-shadow:0 2px 8px rgba(42,39,36,.15)';
  document.body.appendChild(btn);
  btn.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});
  window.addEventListener('scroll',function(){
    btn.style.opacity=window.pageYOffset>600?'1':'0';
    btn.style.visibility=window.pageYOffset>600?'visible':'hidden';
  },{passive:true});
})();

// Smart sticky header
(function(){
  var h=document.querySelector('.shopify-section-group-header-group');
  if(!h)return;
  var last=0;
  window.addEventListener('scroll',function(){
    var c=window.pageYOffset;
    if(c<=80){h.classList.remove('header-hidden');return}
    if(c>last)h.classList.add('header-hidden');
    else h.classList.remove('header-hidden');
    last=c;
  },{passive:true});
})();

